export default function LiveWistiaPlayer({ mediaId }) {
  return (
    <>
      <style>{`
        wistia-player[media-id='${mediaId}']:not(:defined) {
          background: center / cover no-repeat url('https://fast.wistia.com/embed/medias/${mediaId}/swatch');
          display: block;
          padding-top: 56.25%;
        }
      `}</style>
      <wistia-player
        media-id={mediaId}
        swatch="false"
        style={{ width: '100%', minHeight: '360px' }}
      />
    </>
  );
}